import LegalPage, { LegalSection } from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated="December 2025">
      <p>
        Green Financials ("we", "us", or "our") respects your privacy. This
        Privacy Policy explains how we collect, use, share, and protect
        information when you visit greenfinancials.com or interact with our
        services.
      </p>

      <LegalSection title="1. Information We Collect">
        <p>We collect information you voluntarily provide, including:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong className="text-gray-200">Contact details:</strong> first
            name, email address, and phone number when you submit a
            consultation request, recruitment application, or message us via
            WhatsApp.
          </li>
          <li>
            <strong className="text-gray-200">Scheduling details:</strong>{" "}
            preferred call time or appointment slot you select.
          </li>
          <li>
            <strong className="text-gray-200">Recruitment details:</strong>{" "}
            current occupation and any other career information you provide.
          </li>
          <li>
            <strong className="text-gray-200">Automatic data:</strong> basic
            device, browser, and usage information (IP address, page views,
            referrer) collected via standard server logs and analytics tools.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="2. How We Use Your Information">
        <p>We use the information you provide to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Respond to your consultation or recruitment inquiry.</li>
          <li>Schedule and confirm appointments.</li>
          <li>
            Send relevant communications about our insurance and wealth
            strategies (you can opt out at any time).
          </li>
          <li>Improve our website, services, and customer experience.</li>
          <li>Comply with legal, regulatory, and security obligations.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. How We Share Your Information">
        <p>
          We do not sell your personal information. We share it only when
          necessary with:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Licensed insurance professionals or carriers we work with to
            service your request.
          </li>
          <li>
            Trusted service providers (e.g. hosting, scheduling, CRM,
            messaging) under written confidentiality terms.
          </li>
          <li>
            Authorities when required by law, subpoena, or to protect rights
            and safety.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Communications & WhatsApp">
        <p>
          By submitting a form or messaging us on WhatsApp, you consent to be
          contacted at the phone number or email you provided. Standard
          messaging rates may apply. You may opt out at any time by replying
          STOP to a text message or emailing us at the address below.
        </p>
      </LegalSection>

      <LegalSection title="5. Cookies & Tracking">
        <p>
          We use essential cookies to operate the site and optional analytics
          cookies to understand how visitors use our pages. You can disable
          cookies via your browser settings, though some site features may not
          function properly.
        </p>
      </LegalSection>

      <LegalSection title="6. Data Security & Retention">
        <p>
          We use industry-standard security measures (encryption in transit,
          access controls, secure cloud hosting) to protect your data. We
          retain personal information for as long as needed to provide our
          services or comply with legal obligations, then securely delete it.
        </p>
      </LegalSection>

      <LegalSection title="7. Your Rights">
        <p>
          Depending on your location, you may have the right to access,
          correct, delete, or restrict the use of your personal information,
          or to object to certain processing (including under GDPR and CCPA).
          To exercise these rights, contact us at the email address below.
        </p>
      </LegalSection>

      <LegalSection title="8. Children's Privacy">
        <p>
          Our services are intended for adults aged 18 and over. We do not
          knowingly collect information from children under 18. If we learn
          that we have collected such information, we will delete it promptly.
        </p>
      </LegalSection>

      <LegalSection title="9. Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Material
          changes will be communicated via the website. The "Last updated"
          date above reflects the most recent revision.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact Us">
        <p>
          Questions about this policy or your data?
          <br />
          <strong className="text-white">Green Financials</strong>
          <br />
          Email: <span className="text-rolex-light">admingreenfinancials@gmail.com</span>
          <br />
          WhatsApp: +1 (281) 969-6440
        </p>
      </LegalSection>
    </LegalPage>
  );
}
